import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Prompt } from '@anytag/shared-atoms';
import { useEngagementProposalSearch } from '../../hooks';
import { EngagementProposalInfluencersFormValues } from '../../types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const LeaveConfirmModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const { formState, reset: resetForm } = useFormContext<EngagementProposalInfluencersFormValues>();
  const { resetViewMode } = useEngagementProposalSearch();

  return (
    <Prompt
      size="lg"
      open={isOpen}
      when={formState.isDirty}
      title={t('Dialog.Save your changes')}
      description={t('leaveWithoutSaveWarningText')}
      footer={({ reset, proceed }) => ({
        cancelButton: {
          title: t('Button.Leave without saving'),
          onClick: () => {
            resetViewMode();
            resetForm();
            onClose();
            setTimeout(() => {
              proceed?.();
            }, 0);
          }
        },
        submitButton: {
          title: t('Button.Keep editing'),
          onClick: () => {
            reset?.();
            onClose();
          }
        }
      })}
    />
  );
};
